export enum StateInvoice {
	PENDIENTE = 'Pendiente',
	FACTURADA = 'Facturada',
	RECHAZADA = 'Rechazada',
	CANCELADA = 'Cancelada',
	DESCONOCIDO = 'Desconocido',
	PAGADA = 'Pagada',
}
